import { NavLink, Navigate, Outlet } from 'react-router-dom';
import { ApiError, api } from '../lib/api';
import { useCreatorMe } from '../lib/auth';
import { SplashLoader } from '../components/SplashLoader';
import logo from '../assets/logo.svg';
import styles from './CreatorLayout.module.css';

async function logout() {
  try {
    await api.post('/api/creator/logout');
  } catch {
    /* ignore */
  }
  window.location.assign('/creator/login');
}

const TABS = [
  { to: '/creator', label: 'Home', end: true },
  { to: '/creator/profile', label: 'Profile' },
  { to: '/creator/documents', label: 'Documents', id: 'documents' },
  { to: '/creator/medical', label: 'Medical Intake', id: 'medical' },
  { to: '/creator/guidelines', label: 'Brand Guidelines' },
  { to: '/creator/video', label: 'Video Submission' },
  { to: '/creator/messages', label: 'Messages' },
  { to: '/creator/payment', label: 'Payment' },
] as const;

export function CreatorLayout() {
  const me = useCreatorMe();

  if (me.isPending) return <SplashLoader />;
  if (me.isError) {
    if (me.error instanceof ApiError && me.error.status === 401) {
      return <Navigate to="/creator/login" replace />;
    }
    return <SplashLoader />;
  }

  const data = me.data;
  const name = data.submission?.fullName || data.email || '';
  const first = name.split(' ')[0] || '';
  const initials =
    name
      .split(' ')
      .slice(0, 2)
      .map((w) => w[0] || '')
      .join('')
      .toUpperCase() || '?';

  const signed = data.all_documents_signed === true;
  const subStatus = data.submission?.status || '';

  function tabDot(id: string | undefined) {
    if (!id) return null;
    if (id === 'documents') {
      if (signed) return <span className={`${styles.navTabDot} ${styles.dotDone}`} />;
      if (subStatus === 'pending_signature' || subStatus === 'ready_for_contract')
        return <span className={`${styles.navTabDot} ${styles.dotAction}`} />;
    }
    if (id === 'medical' && signed) {
      return <span className={`${styles.navTabDot} ${styles.dotDone}`} />;
    }
    return null;
  }

  return (
    <div className={styles.shell}>
      <nav className={styles.topNav}>
        <img src={logo} alt="Kick" className={styles.navLogo} />
        <div className={styles.navTabs}>
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={'end' in t ? t.end : false}
              className={({ isActive }) =>
                `${styles.navTab} ${isActive ? styles.navTabActive : ''}`
              }
            >
              {t.label}
              {tabDot('id' in t ? t.id : undefined)}
            </NavLink>
          ))}
        </div>
        <div className={styles.navRight}>
          <span className={styles.navCreatorName}>{first}</span>
          <div className={styles.navAvatar}>{initials}</div>
          <button type="button" className={styles.btnSignout} onClick={logout}>
            Sign out
          </button>
        </div>
      </nav>
      <div className={styles.page}>
        <Outlet />
      </div>
    </div>
  );
}
